import ai from './ai.json'
import controls from './controls.json'
import menu from './menu.json'
import misc from './misc.json'
import modal from './modal.json'
import navbar from './navbar.json'
import notification from './notification.json'
import searchReport from './searchReport.json'
import sources from './sources.json'

export default {
  ...ai,
  ...controls,
  ...menu,
  ...misc,
  ...modal,
  ...navbar,
  ...notification,
  ...searchReport,
  ...sources
}



// WEBPACK FOOTER //
// ./src/locales/en-uk/index.js